import { render, staticRenderFns } from "./PromotionUpsellGridImage.vue?vue&type=template&id=9227d520&"
import script from "./PromotionUpsellGridImage.vue?vue&type=script&lang=ts&"
export * from "./PromotionUpsellGridImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports